import l from "styled-components";
import { Icon as c } from "./atoms-v217.js";
import { Text as n } from "./atoms-v243.js";
import { getInputPaddingForIcons as i, getInputMarginForIcons as t } from "./atoms-v21001.js";
const p = l.button`
  align-items: center;
  align-self: flex-start;
  background-color: transparent;
  border: none;
  border-radius: ${({ $isRounded: r, theme: o }) => r ? `${o == null ? void 0 : o.get("tokens.radius.buttonFullRounded")}px` : `${o == null ? void 0 : o.get("tokens.radius.buttonSmallRounded")}px`};
  cursor: ${({ $isDisabled: r }) => r ? "arrow" : "pointer"};
  display: flex;
  justify-content: center;
  padding: ${({ $hasLeftIcon: r, $hasRightIcon: o }) => i(r, o)};
  width: max-content;

  &:focus-visible {
    border: 1px solid ${({ $colorTheme: r, theme: o }) => o == null ? void 0 : o.get(`ui.selector.${r}.selectorFocus`)};
  }

  &:hover:not([disabled]) {
    background-color: ${({ $colorTheme: r, theme: o }) => o == null ? void 0 : o.get(`ui.selector.${r}.selectorBkgHover`)};
  }

  &:active:not([disabled]) {
    background-color: ${({ $colorTheme: r, theme: o }) => o == null ? void 0 : o.get(`ui.selector.${r}.selectorBkgActive`)};
  }
`, $ = l.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${({ $size: r }) => r === "small" ? "2px" : "0"};
  justify-content: center;
  margin: ${({ $hasLeftIcon: r, $hasRightIcon: o }) => t(r, o)};
`, b = l(n)`
  color: ${({ $colorTheme: r, $isDisabled: o, theme: s }) => o ? s == null ? void 0 : s.get(`ui.selector.${r}.selectorDisabled`) : s == null ? void 0 : s.get(`ui.selector.${r}.selectorLabel`)};

  ${({ $size: r, theme: o }) => o == null ? void 0 : o.get(`${r === "small" ? "tokens.helper.productive" : "tokens.helper.expressive"}`).toJS()};
`, x = l(n)`
  color: ${({ $colorTheme: r, $isDisabled: o, theme: s }) => o ? s == null ? void 0 : s.get(`ui.selector.${r}.selectorDisabled`) : s == null ? void 0 : s.get(`ui.selector.${r}.selectorOption`)};

  ${({ $size: r, theme: o }) => o == null ? void 0 : o.get(`${r === "small" ? "tokens.body.compact-productive" : "tokens.body.compact-expressive"}`).toJS()};
`, f = l(c)`
  color: ${({ $colorTheme: r, $isDisabled: o, theme: s }) => o ? s == null ? void 0 : s.get(`ui.selector.${r}.selectorDisabled`) : s == null ? void 0 : s.get(`ui.selector.${r}.selectorIcon`)};
  display: flex;
  flex-shrink: 0;
`;
export {
  b as Label,
  p as SelectorButtonContainer,
  $ as SelectorButtonInterior,
  f as SelectorIcon,
  x as Value
};
